<!-- Start Client Intro Section -->
<section class="ready-to-talk">
    <div class="container">
        <div class="ready-to-talk-content">
            <h3>{{ 'home.our-clients.title' | translate }}</h3>
            <p>{{ 'home.our-clients.p-1' | translate }}</p>
        </div>
    </div>
</section>
<!-- End Client Intro Section-->